<template>
	<div>
		<BaseNav></BaseNav>
		<div class="content">
			
		</div>
		<BaseFooter></BaseFooter>
	</div>
</template>

<script>
	import BaseNav from "@/components/BaseNavigation"
	import BaseFooter from "@/components/BaseFooter"
	export default{
		components:{
			BaseNav,
			BaseFooter
		},
		data(){
			return{
				
			}
		},
		mounted(){
			document.title="雄安股权交易所-培训路演";
		},
		methods:{
			
		}
	}
</script>

<style scoped="scoped">
	.content{
		min-height: 500px;
	}
</style>



// WEBPACK FOOTER //
// src/pages/train/train.vue